
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";

import { Head } from "@/components/Head";
import { useTheme } from "@/hooks/useTheme";
import { Converter } from "@/containers/Converter";

import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { CTASection } from "@/sections/CTASection";
import { ShareDesignSection } from "@/sections/ShareDesignSection";
import { PricingSection } from "@/sections/PricingSection";
import { ConversionSection } from "@/sections/ConversionSection";

const PowerPointToAi = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <>
      <Head
        pageNamespace="page/PowerPointToAi"
        ogImage="/images/powerpoint2ai-og-image.jpg"
      />

      <MagicianSection
        title={t("page/PowerPointToAi:title")}
        subtitle={t("page/PowerPointToAi:subtitle")}
        magicianLogoFile="ai"
        cta={{
          title: t("section/magicians:scrollTo"),
          scrollToId: "ApiTeaserSection",
        }}
      >
        <Converter />
      </MagicianSection>

      <TrustedBySection />

      <ApiTeaserSection
        title={
          ((
            <Trans
              i18nKey="page/PowerPointToAi:section/apiTeaser.title"
              components={[<span style={{ color: colors.ORANGE }} key={0} />]}
            />
          ) as unknown) as string
        }
        backgroundColor="#fffffe"
        cta={{
          title: t("common:actions.doNow", { do: t("common:actions.convert") }),
        }}
        elements={t(
          "page/PowerPointToAi:section/apiTeaser.apiTeaserElements",
          null,
          {
            returnObjects: true,
          },
        )}
        image={{
          src: "/images/powerpoint-to-ai-example.png",
          alt: "Powerpoint to Illustrator Example",
        }}
      />

      <ShareDesignSection
        id="ShareDesignSection"
        title={
          ((
            <Trans
              i18nKey="page/PowerPointToAi:section/shareDesign.title"
              components={[<span key="0" style={{ color: colors.ORANGE }} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/powerpoint-to-ai-converted-file-elements.jpg",
          alt: t("page/PowerPointToAi:section/shareDesign.imageAlt"),
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("page/PowerPointToAi:section/shareDesign.ctaButton"),
        }}
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "SPREAD-ICON",
            title: t(
              "page/PowerPointToAi:section/shareDesign.elements.pathElementsTitle",
            ),
            text: t(
              "page/PowerPointToAi:section/shareDesign.elements.pathElementsText",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "FOLDER-SIMPLE-ICON",
            title: t(
              "page/PowerPointToAi:section/shareDesign.elements.folderStructureTitle",
            ),
            text: t(
              "page/PowerPointToAi:section/shareDesign.elements.folderStructureText",
            ),
          },
          {
            id: "ELEMENT#3",
            iconType: "CHECK-CIRCLED-EMPTY",
            title: t(
              "page/PowerPointToAi:section/shareDesign.elements.imageSupportTitle",
            ),
            text: t(
              "page/PowerPointToAi:section/shareDesign.elements.imageSupportText",
            ),
          },
        ]}
      />

      <PricingSection />
      <ConversionSection
        title={t("page/PowerPointToAi:section/conversion.title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t(
              "page/PowerPointToAi:section/conversion.badges.supportsAll",
            ),
          },
          {
            iconType: "SYNC-ICON",
            text: t("page/PowerPointToAi:section/conversion.badges.allPath"),
          },
          {
            iconType: "SYNC-ICON",
            text: t(
              "page/PowerPointToAi:section/conversion.badges.fullArtboard",
            ),
          },
        ]}
        elements={{
          from: {
            iconType: "POWERPOINT",
            image: "/images/powerpoint-preview.jpg",
            title: "Powerpoint Demo Preview",
          },
          to: {
            iconType: "AI",
            image: "/images/illustrator-preview-powerpoint.jpg",
            title: "Adobe Illustrator Import Demo Preview",
          },
        }}
      />

      <SelectFormatSection title={t("section/selectFormat:title")} />

      <CTASection
        title={t("section/cta:titles.powerpointToAiPage")}
        href="#upload"
      />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default PowerPointToAi;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/powerpoint-to-ai',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  